import { BiCheck } from "react-icons/bi";
import "./services.css";
import { services } from "../../utils/websiteData";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services-container">
        {services.map((service, index) => {
          const { serviceDetails, serviceName } = service;
          return (
            <article key={index} className="service">
              <div className="service-head">
                <h3>{serviceName}</h3>
              </div>

              <ul className="service-list">
                {serviceDetails.map((detail, i) => {
                  return (
                    <li key={i}>
                      <BiCheck className="service-list-icon" />
                      <p>{detail}</p>
                    </li>
                  );
                })}
              </ul>
            </article>
          );
        })}
      </div>
    </section>
  );
};
export default Services;
